import { render, staticRenderFns } from "./ModalFurtoSimplesQualificado.vue?vue&type=template&id=2bc5c72d"
import script from "./ModalFurtoSimplesQualificado.vue?vue&type=script&lang=js"
export * from "./ModalFurtoSimplesQualificado.vue?vue&type=script&lang=js"
import style0 from "./ModalFurtoSimplesQualificado.vue?vue&type=style&index=0&id=2bc5c72d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports